import { track } from '../misc/utils';

export const undo = () => state => {
  if (state.actions.length < 1) {
    track.event('button', 'click', 'undo');
    return;
  }
  const latestAction = state.actions.pop();
  const target = state.stickers[latestAction.target];
  track.event('button', 'undo', latestAction.type);

  switch (latestAction.type) {
    case "ADD":
      state.stickers[latestAction.target].skip = true;
      state.active = "";
      state.activeType = "";
      break;
    case "EDIT":
      state.stickers[latestAction.target].zIndex =
        latestAction.prevState.zIndex;
      state.stickers[latestAction.target].pos =
        latestAction.prevState.pos || target.pos;
      state.stickers[latestAction.target].rotation =
        `${latestAction.prevState.rotation}` || target.rotation;
      state.stickers[latestAction.target].scale =
        latestAction.prevState.scale || target.scale;
      break;
    case "DELETE":
      state.stickers[latestAction.target].skip = false;
      state.active = target.refName;
      state.activeType = target.type;
      break;
    default:
      break;
  }

  return state;
};

export const onTap = (evt, sticker) => state => {
  state.active = sticker.refName;
  state.activeType = sticker.type;

  return state;
};

let allowPan = true;

export const onPanStart = (evt, mouseDown) => {
  // Prevent stickers hiding on scroll - ideally need to find a better way of dealing with this
  if (Math.abs(evt.deltaX) > 50 || Math.abs(evt.deltaY) > 50 || mouseDown) {
    allowPan = false;
  }
};

export const onPanMove = (evt, sticker) => state => {
  if (!allowPan || state.active !== sticker.refName) {
    return;
  }

  sticker.pos.x = sticker.prevState.pos.x + evt.deltaX;
  sticker.pos.y = sticker.prevState.pos.y + evt.deltaY;

  return state;
};

export const onPanEnd = (evt, sticker) => state => {
  state.actions.push({
    type: "EDIT",
    target: sticker.refName,
    prevState: {
      ...sticker.prevState,
      pos: { x: sticker.prevState.pos.x, y: sticker.prevState.pos.y }
    }
  });

  sticker.prevState.pos.x = sticker.pos.x;
  sticker.prevState.pos.y = sticker.pos.y;

  allowPan = true;

  return state;
};



// WEBPACK FOOTER //
// ./src/actions/preview.js